/**
 * One place for session status colours (plan 3f). DaisyUI semantic tokens
 * only, so light and dark themes stay readable without `dark:` overrides.
 *
 * Parity with iOS/Android: Logged = success, To log / Live = warning,
 * Planned = neutral, Proposed = info, Rejected = error.
 */
import type { Session } from "../types/post";

export type SessionStatus = Session["status"] | string;

/** Chip classes for a raw status value (`session.status`). */
export const sessionStatusChipClass = (status: SessionStatus): string => {
  switch (status) {
    case "complete":
      return "bg-success/15 text-success";
    case "executing":
      return "bg-warning/15 text-warning";
    case "proposed":
      return "bg-info/15 text-info";
    case "rejected":
      return "bg-error/10 text-error";
    case "planned":
    default:
      return "bg-base-content/10 text-base-content/70";
  }
};

/** Shared chip typography: small caps label in Grotesk. */
export const STATUS_CHIP_BASE =
  "inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide font-grotesk";
